<ng-container *ngIf="isMobile; else desktopTemplate">
  <molec-rd-tab-mobile class="pt-10" [tabs]="tabs"></molec-rd-tab-mobile>
  <router-outlet></router-outlet>
</ng-container>

<ng-template #desktopTemplate>
  <molec-tab-left-desktop [style]="options.desktopStyle" [tabs]="tabs"> </molec-tab-left-desktop>
</ng-template>